import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "md:px-3 lg:px-6 pt-2 gap-2 lg:gap-6 h-screen" }
const _hoisted_3 = {
  for: "userInput",
  class: "block mt-1 mb-auto select-none"
}
const _hoisted_4 = { class: "text-2xl font-medium" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Text2Graph", -1)
const _hoisted_7 = { class: "flex-grow" }
const _hoisted_8 = ["placeholder", "disabled", "rows"]
const _hoisted_9 = { class: "mt-1 text-left" }
const _hoisted_10 = ["checked", "disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "w-full bg-red-400 rounded-md mt-4 text-white"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://status.openai.com/",
  target: "_blank",
  rel: "noopener noreferrer"
}, "https://status.openai.com/", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "h-2/3" }
const _hoisted_17 = { class: "mt-2 md:mt-4 flex h-full" }
const _hoisted_18 = { class: "flex w-2/3" }
const _hoisted_19 = { class: "mt-2 md:mt-4 flex h-20" }
const _hoisted_20 = { class: "flex w-full bg-white rounded-md text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Graph = _resolveComponent("Graph")!
  const _component_history = _resolveComponent("history")!
  const _component_RelatedGraph = _resolveComponent("RelatedGraph")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("form", {
          class: _normalizeClass(["flex items-center p-2 md:p-6 gap-2 md:gap-6 self-stretch rounded-md", _ctx.bg_color]),
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFormSubmit && _ctx.handleFormSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("label", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("home.question")), 1),
            _hoisted_5,
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("textarea", {
              type: "text",
              class: "w-full p-2 border rounded-md",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userInput) = $event)),
              placeholder: _ctx.$t('home.user_input_question'),
              disabled: _ctx.isLoading,
              rows: _ctx.textRows
            }, null, 8, _hoisted_8), [
              [_vModelText, _ctx.userInput]
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("input", {
                type: "checkbox",
                value: "foo",
                checked: _ctx.mergeGraph,
                disabled: !_ctx.selected_graph_id,
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMergeGraph && _ctx.toggleMergeGraph(...args))),
                class: "bg-gray-50 border border-gray-300 mr-2",
                id: "mergeGraph"
              }, null, 40, _hoisted_10),
              _createElementVNode("label", {
                for: "mergeGraph",
                class: _normalizeClass(["select-none", !_ctx.selected_graph_id ? 'text-gray-300' : ''])
              }, _toDisplayString(_ctx.$t("home.merge_graph")), 3)
            ])
          ]),
          _createElementVNode("input", {
            type: "submit",
            value: "Submit",
            class: _normalizeClass(["py-2 px-4 text-white rounded cursor-pointer block mt-0 mb-auto", _ctx.isLoading ? 'bg-blue-200' : 'bg-blue-500']),
            disabled: _ctx.isLoading
          }, null, 10, _hoisted_11)
        ], 34)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["w-full h-3 bg-white rounded-md mt-4", _ctx.isLoading ? 'loading block' : 'hidden'])
      }, " ", 2),
      (_ctx.serverError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t(`home.${_ctx.serverError}`)), 1),
            (_ctx.serverError === 'openai_down_error')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_Graph, {
              class: "flex-col w-full bg-white rounded-md mr-6",
              graph_data: _ctx.graph_data,
              onUpdate_position: _ctx.updatePosition,
              onSelect_graph: _ctx.selectGraph,
              is_loading: _ctx.isLoading
            }, null, 8, ["graph_data", "onUpdate_position", "onSelect_graph", "is_loading"])
          ]),
          (_ctx.user)
            ? (_openBlock(), _createBlock(_component_history, {
                key: 0,
                class: "w-1/3 bg-white rounded-md overflow-y-scroll",
                graph_id: _ctx.selected_graph_id,
                onUpdate_graph_data: _ctx.setGraphData,
                onPresent_question: _ctx.present_question,
                select_data: _ctx.select_data
              }, null, 8, ["graph_id", "onUpdate_graph_data", "onPresent_question", "select_data"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_RelatedGraph, {
              if: "user && selected_graph_id",
              class: "overflow-y-scroll w-full",
              uid: _ctx.user.uid,
              graph_id: _ctx.selected_graph_id,
              onUpdate_graph_data: _ctx.setGraphData
            }, null, 8, ["uid", "graph_id", "onUpdate_graph_data"])
          ])
        ])
      ])
    ])
  ]))
}